/**
 * ParticipantFeedbackSection Component
 * Thin wrapper around SurveyResultsContent for session-scoped post-session feedback.
 */

import { SurveyResultsContent } from './SurveyResultsContent';

interface ParticipantFeedbackSectionProps {
  cohortId: string;
  sessionId: string;
  groupId?: string;
}

export function ParticipantFeedbackSection({
  cohortId,
  sessionId,
  groupId,
}: ParticipantFeedbackSectionProps) {
  return (
    <SurveyResultsContent
      cohortId={cohortId}
      formType="post_session"
      sessionId={sessionId}
      groupId={groupId}
    />
  );
}

export default ParticipantFeedbackSection;
